import * as React from "react"

const CalenderIcon = (props) => (
  <svg
    width={18}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.5 2h-2.25v-.75a.75.75 0 1 0-1.5 0V2h-7.5v-.75a.75.75 0 0 0-1.5 0V2H1.5A1.501 1.501 0 0 0 0 3.5v15A1.501 1.501 0 0 0 1.5 20h15a1.502 1.502 0 0 0 1.5-1.5v-15A1.502 1.502 0 0 0 16.5 2ZM6.75 16.625a2.236 2.236 0 0 1-1.59-.658.75.75 0 0 1 1.06-1.061.75.75 0 1 0 .53-1.281.745.745 0 0 1-.07-.004l-.023-.002a.74.74 0 0 1-.114-.024l-.026-.007a.8.8 0 0 1-.042-.015l-.022-.01a.772.772 0 0 1-.048-.023l-.014-.006a.741.741 0 0 1-.058-.036l-.019-.013-.033-.024-.004-.004-.032-.029-.024-.021-.02-.023a.754.754 0 0 1-.183-.348l-.002-.007-.006-.039c-.002-.011-.005-.023-.006-.035 0-.01 0-.02-.002-.029L6 12.88v-.005L6 12.852c0-.016 0-.031.002-.047l.004-.03.007-.043.007-.032.01-.039.011-.033.013-.036.016-.034.015-.032.02-.034.018-.03.025-.034.015-.022.525-.656H5.625a.75.75 0 1 1 0-1.5H8.25a.75.75 0 0 1 .585 1.219l-.831 1.039a2.25 2.25 0 0 1-1.254 4.117Zm6-.75a.75.75 0 1 1-1.5 0V12.5l-.3.225a.75.75 0 1 1-.9-1.2l1.5-1.125a.75.75 0 0 1 1.2.6v4.875ZM16.5 6.5h-15v-3h2.25v.75a.75.75 0 0 0 1.5 0V3.5h7.5v.75a.75.75 0 1 0 1.5 0V3.5h2.25v3Z"
      fill="#009FFF"
    />
  </svg>
)

export default CalenderIcon
